/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_LabelInputs */



/**
* | output |
* | --- |
* | "API Keys Table" |
*
* @param {Options_Api_Keys_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_label = /** @type {((inputs?: Options_Api_Keys_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau des clés API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüsseltabelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tabella delle chiavi API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таблица ключей API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tabla de claves API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("API密钥表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーテーブル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी तालिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tabela de chaves de API")
	return /** @type {LocalizedString} */ ("API Keys Table")
});